import { useCurrency } from '@blend-ed/blendx-platform/hooks';
import { Badge, Button, Image, useMediaQuery } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import placeholderDark from '../assets/images/placeholder-dark.png';
import placeholder from '../assets/images/placeholder.jpg';
import messages from './messages';

const getDurationMetricMessage = (metric, intl) => {

  const isTablet = useMediaQuery({ query: '(min-width: 768px)' });

  const metricMap = {
    'hours': messages.durationMetricHours,
    'days': messages.durationMetricDays,
    'weeks': messages.durationMetricWeeks,
    'months': messages.durationMetricMonths,
    'years': messages.durationMetricYears
  };
  return isTablet ? intl.formatMessage(metricMap[metric.toLowerCase()] || metricMap['days']) : metric.slice(0, 1);
};

const ProgramCard = ({ intl, title, description, estimatedTime, durationMetric, link, image, price, courseCount, discover, size }) => {
  const navigate = useNavigate();
  const { symbol } = useCurrency();
  const isTablet = useMediaQuery({ query: '(min-width: 768px)' });

  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

  return (
    <div
      className={classNames(
        "program-card",
        `program-card-${size}`,
        { 'program-card--clickable': !isTablet }
      )}
      onClick={() => !isTablet && navigate(link)}
    >
      <div className="program-card__image-container">
        <Image
          src={image}
          alt={title}
          className="program-card__image"
          onError={(e) => {
            e.target.src = isDarkMode ? placeholderDark : placeholder;
          }}
        />
      </div>
      <div className="program-card__content">
        <div className="program-card__body">
          {!isTablet && <div>
            <Badge className="program-card__badge" size="xxs" variant="light-purple">
              {intl.formatMessage(messages.programBadge)}
            </Badge>
          </div>}
          <div className="program-card__head">
            <div className="program-card__title">
              {title}
            </div>
            {discover && isTablet && <div className="program-card__price">
              {price === 0 ? intl.formatMessage(messages.free) : `${symbol} ${price}`}
            </div>}
          </div>
          {isTablet && <div className="program-card__description text-truncate">
            {description}
          </div>}
          <div className="program-card__badges">
            {estimatedTime && <Badge className="program-card__badge" iconBefore="time" iconType="line" size="xxs" variant="disabled">
              {estimatedTime} {getDurationMetricMessage(durationMetric, intl)}
            </Badge>}
            <Badge className="program-card__badge" iconBefore="book-2" iconType="line" size="xxs" variant="disabled">
              {courseCount} {isTablet ? intl.formatMessage(messages.coursesCountLabel) : ''}
            </Badge>
          </div>
        </div>
        {(isTablet || discover) && <div className="program-card__footer">
          {isTablet ? (<Button onClick={() => navigate(link)} variant="primary" size="xs">
            {intl.formatMessage(messages.viewProgramDetails)}
          </Button>) : (discover && <div className="program-card__price">
            {price === 0 ? intl.formatMessage(messages.free) : `${symbol} ${price}`}
          </div>)}
        </div>}
      </div>
    </div>
  );
}

ProgramCard.propTypes = {
  title: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  estimatedTime: propTypes.string.isRequired,
  link: propTypes.string.isRequired,
  image: propTypes.string.isRequired,
  durationMetric: propTypes.string,
  price: propTypes.number,
  courseCount: propTypes.number,
  discover: propTypes.bool,
  intl: intlShape.isRequired,
}

ProgramCard.defaultProps = {
  price: 0,
  courseCount: 0,
  discover: false,
  durationMetric: 'Days',
}


export default injectIntl(ProgramCard);